
let pathPrefix;
if (location.host == 'aayu.app' || location.host == 'aayuapp.mcords.co.in')
  pathPrefix = 'pwa/'
else
  pathPrefix = ''

export const ScreenRoute = {

  splash: pathPrefix + 'splash',
  login: pathPrefix + 'login',
  otp: pathPrefix + 'otp',
  complete_profile: pathPrefix + 'family/complete_profile',

  dashboard_screen: 'dashboard',
  tab_controller_screen: pathPrefix + 'home',

  profile_screen: 'dashboard/profile',
  list_member: pathPrefix + 'profile/members',
  upsert_family_data: pathPrefix + 'profile/upsert_member',

  transaction_history: pathPrefix + 'profile/transactions',

  acs_plans: pathPrefix + 'acs/plans',
  acs_quiz: pathPrefix + 'acs/quiz',
  acs_plan_recommender: pathPrefix + 'acs/plan_recommender',
  acs_current_plan: pathPrefix + 'acs/current_plan',

  econsult_start: pathPrefix + 'econsult/start',
  member_selection: pathPrefix + 'econsult/select_member',
  problem_selection: pathPrefix + 'econsult/select_problem',
  questionaire_screen: pathPrefix + 'econsult/questionnaire',
  review_answer: pathPrefix + 'econsult/review_answers',

  econsult_success: pathPrefix + 'econsult/success',
  econsult_details: pathPrefix + 'econsult/details',
  econsult_pdf_erx_view: pathPrefix + 'econsult/pdf_erx',
  payment_online: pathPrefix + 'payment/online',

  choose_acs_plan: pathPrefix + 'payment/choose_acs_plan',
  payment_acs: pathPrefix + 'payment/acs',

  search_locality: pathPrefix + 'cart/location/search_locality', // common, used by oms and profile

  oms_detect_user_location: pathPrefix + 'cart/location/detect',

  list_pharmacy: pathPrefix + 'cart/pharmacy/list',
  search_medicine: pathPrefix + 'cart/order/search',
  autocomplete_medciine_search: pathPrefix + 'cart/search/autocomplete',

  product_categories: pathPrefix + 'inventory_category',
  search_deals: pathPrefix + 'deals/search',
  selected_deals: pathPrefix + 'deals/view',

  review_oms_order: pathPrefix + 'cart/order/review',
  order_successful: pathPrefix + 'orders/order/success',

  oms_message_view: pathPrefix + 'orders/order/messages',
  view_order_summary: pathPrefix + 'orders/order/summary',
  view_order_details: pathPrefix + 'orders/order/details',

  list_user_services: pathPrefix + 'service/list',

  list_orders: pathPrefix + 'orders/list',

  // Wil check
  site_store_profile: pathPrefix + 'store_profile',
  selected_pharmacy: pathPrefix + 'oms/store_profile',

  chemist_store_profile_view: pathPrefix + 'home/about_store',

  custom_checkout: pathPrefix + 'payment/custom_checkout',
  wallet_netbanking_mods_list: pathPrefix + 'payment/wallet_netbanking_mods_list',
  oms_offers: pathPrefix + 'payment/promo_codes',
  card_input: pathPrefix + 'payment/checkout/card_input',
  payment_success_failed: pathPrefix + 'payment/payment_status',

  notification_list: pathPrefix + 'notifications',
  offers_list: pathPrefix + 'profile/offers/list',
  selected_offer: pathPrefix + 'profile/offers/view',
  rewards_screen: pathPrefix + 'profile/rewards',

  address_list: pathPrefix + 'profile/address/list',
  upsert_user_address: pathPrefix + 'profile/address/upsert',

  images_preview: pathPrefix + 'images_preview',
  // title_popup: pathPrefix + 'title_popup',

  home: pathPrefix + 'home',
  cart: pathPrefix + 'cart',
  orders: pathPrefix + 'orders',
  profile: pathPrefix + 'profile',
}


export const ancestorRouteMapping = {

  dashboard: null,
  tab_controller: null,
  splash: ScreenRoute.tab_controller_screen,

  econsult_submission: null,
  order_success: null,

  'oms/pharmacy/list': ScreenRoute.tab_controller_screen,
}

export const eventDispatchingMapping = {
  [ScreenRoute.questionaire_screen]: {
    questionaireFlowExit: true
  },
  [ScreenRoute.review_answer]: {
    reviewQuestionAnswerFlowExit: true
  },
  [ScreenRoute.payment_online]: {
    paymentSurvey: true
  },
  [ScreenRoute.payment_acs]: {
    acsPaymentExitFlow: true
  }
}

export const NavigateFrom = {
  dashboard_for_econsult: 'create_econsult', // navigate to 'first_econsult' : 'econsult_select_family_member'

  econsult_success: 'econsult_created', // navigate to econsut details

  payment_online: 'aayu_card', // navigate to pre/post purcahse

  acs_plan_recommender: 'buy_aayu_card', // navigate to service payment/post purcahse
  acs_plans: 'buy_aayu_card', // navigate to service payment/post purcahse

  profile: "profile", // profile

  complete_proifle_for_search_location: 'complete_profile', // pop back to same screen

  list_pharmacy: 'list_pharmacy', // navigate to pharmacy list
  review_oms_order: 'review_order',


  site_store_profile: 'store_profile',
  selected_pharmacy: 'oms_store_profile', // navigate to selected pharmacy

  order_successful: 'oms_created', // navigate to oms details
  view_order_details: 'oms_order_accepted', // navigate to oms message view

  oms_order_delivered: 'oms_order_delivered', // naviage to oms details

  view_order_summary: 'oms_canceled', // navigate to oms details


  save_location_for_search_locality: 'upsert_user_location', // navigate to update user location

  add_address_for_create_order: 'create_order', // place order from otp screen

  login_from_profile: 'profile_login', // navigate back to chemist store

  deeplink_message_view: 'deeplink_message_view', // pop back to message view
  deeplink_order_summary: 'deeplink_order_summary', // pop back to order summary

  pharmacy_list_for_search_location: 'pharmacy_list_for_search_location',

  oms_message_view: 'oms_message_view',
  search_medicne_for_review_order: 'search_medicine_review_order',
  cart_component_for_search_medicine: 'add_more_for_search_medicine',
}